export enum EScrollUpButtonType {
  Filters = 'filters',
  Up = 'up',
}

export type ScrollUpButtonProps = {
  onClick: () => void;
  iconType: EScrollUpButtonType;
  testId?: string;
};
